/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Upload_Error_TimeoutInputs */

const en_mobile_upload_error_timeout = /** @type {(inputs: Mobile_Upload_Error_TimeoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload timed out. Please try again.`)
};

const es_mobile_upload_error_timeout = /** @type {(inputs: Mobile_Upload_Error_TimeoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La subida agotó el tiempo de espera. Inténtalo de nuevo.`)
};

/**
* | output |
* | --- |
* | "Upload timed out. Please try again." |
*
* @param {Mobile_Upload_Error_TimeoutInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_upload_error_timeout = /** @type {((inputs?: Mobile_Upload_Error_TimeoutInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Upload_Error_TimeoutInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_upload_error_timeout(inputs)
	return en_mobile_upload_error_timeout(inputs)
});